// extracted by mini-css-extract-plugin
module.exports =  {"debugger":"debugger--DRdgK","content":"content--dEr3M"};